export default "__VITE_ASSET__BB6hZxvI__"